import { PostFundingSourcesFundingSourceIdVerifyRequest } from '@melio/platform-api-axios-client';
import { convertDollarsToCents } from '@melio/platform-utils';

export const convertVerifyParamsDollarsToCents = (params: PostFundingSourcesFundingSourceIdVerifyRequest) =>
  convertDollarsToCents(params, ['amount1', 'amount2']);
